import BaseSetup from '@/components/BaseSetup';
import { Reactive } from '@/utils/decorators';
import { } from 'vue';

export type SharedTagDotsExpandableEmits = {};
export type SharedTagDotsExpandableProps = {
	tags?: ITagListItemModel[]
	tagLinks?: (ITagLinkModel | ITagUserModel)[]
};

export default class SharedTagDotsExpandableSetup extends BaseSetup {

	static readonly defaultProps = {
		tags: () => [],
		tagLinks: () => [],
	};

	@Reactive private readonly state = {};

	constructor (
		private props: SharedTagDotsExpandableProps,
		private emits: SharedTagDotsExpandableEmits,
	) {
		super();
	}

	get formattedTags (): { name?: string, color?: Orion.ColorExtended }[] {
		let res: { name?: string, color?: Orion.ColorExtended }[] = [];
		if (this.props.tags?.length) {
			res = this.props.tags.map(t => ({
				name: t.name,
				color: t.color?.name as Orion.ColorExtended,
			}));
		}
		else if (this.props.tagLinks?.length) {
			res = this.props.tagLinks.map(t => ({
				name: t.tagName,
				color: t.tagColorName as Orion.ColorExtended,
			}));
		}
		return res.map(x => ({
			...x,
			color: x.color?.replace(/(grad|light)/, 'alt') as Orion.ColorExtended,
		}));
	}

}
